export default __webpack_public_path__ + "img/decNVVpe.3f176c0b.svg";